export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标签名称',
    dataIndex: 'name',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'name',
    lable: '标签名称',
    lableCol: 4,
    wrapperCol: 18,
  },
];